import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { storageService } from '../services/storage';
import { clearDeviceConstantsOnLogout } from '../hooks/useDeviceConstantsStore';

export interface User {
  id: number;
  username: string;
  email: string;
  user_type: 'admin' | 'client' | 'sub';
  status: 'active' | 'disabled';
  client_id: number;
  parent_id?: number;
  created_at: string;
  updated_at: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<User>) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      
      login: (user: User, token: string) => {
        set({
          user,
          token,
          isAuthenticated: true,
        });
      },
      
      logout: () => {
        // 清除记住的密码
        storageService.clearRememberedCredentials();
        
        // 清理设备常量缓存
        clearDeviceConstantsOnLogout();
        
        set({
          user: null,
          token: null,
          isAuthenticated: false,
        });
      },
      
      updateUser: (userData: Partial<User>) => {
        const currentUser = get().user;
        if (currentUser) {
          set({
            user: { ...currentUser, ...userData },
          });
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
); 